@if (countryList) {
  <p-select
    [appendTo]="'body'"
    (onChange)="onCountryChange($event)"
    [options]="countryList"
    [(ngModel)]="country"
    [required]="required()"
    [placeholder]="country || placeholder()"
    [filter]="true"
    filterBy="label, value"
    [disabled]="disabled()"
  >
  </p-select>
}
